<!-- <form [formGroup]="createGateInForm">
    <div class="main-container"
        style="display: flex; justify-content: space-between; align-items: flex-start; flex-wrap: wrap;flex-direction:column">
        <div class="main">
            <p-card>
                <div style="display: flex; justify-content: space-between; align-items: flex-start;">
                    <div class="dropdown-section mr-3" style="min-width:100">
                        <div>
                            <label>Token No</label>
                        </div>
                        <div>
                            <p-dropdown [options]="token_no_list" optionLabel="token_no" [filter]="true"
                                filterBy="token_no" [showClear]="true" placeholder="Select a Token No"
                                (onChange)="onTokenNoSelected($event.value)">
                                <ng-template pTemplate="selectedItem" let-selectedOption>
                                    <div class="flex align-items-center gap-2">
                                        {{ selectedOption?.token_no }}
                                    </div>
                                </ng-template>
                                <ng-template let-token pTemplate="item">
                                    <div class="flex align-items-center gap-2">
                                        {{ token?.token_no }}
                                    </div>
                                </ng-template>
                            </p-dropdown>
                        </div>
                    </div>

                    <div class="dropdown-section mr-3" style="min-width:100">
                        <div>
                            <label>Vendor</label>
                        </div>
                        <div>
                            <p-dropdown [options]="vendor_list" placeholder="Select Vendor"
                                (onChange)="getselectedVendorPoList($event.value)"></p-dropdown>
                        </div>
                    </div>

                    <div class="dropdown-section mr-3" style="min-width:100">
                        <div>
                            <label>PO</label>
                        </div>
                        <div>
                            <p-multiSelect [options]="all_po_list" optionLabel="name" placeholder="Select PO"
                                (onChange)="onMultiSelectChange($event)"></p-multiSelect>
                        </div>
                    </div>
                </div>
            </p-card>
        </div>
        <div class="col-12 md:col-6" style="flex: 1; min-width: 0; padding-left: 10px;">
            <p-card>
                <div class="p-fluid">
                    <h5>Receiving Detail</h5>
                    <div class="p-formgrid grid">
                        <div class="field col">
                            <label>Purpose<span class="required-asterisk">*</span></label>
                            <input pInputText formControlName="purpose" />
                        </div>
                        <div class="field col">
                            <label>Plant<span class="required-asterisk">*</span></label>
                            <input pInputText formControlName="plant" />
                        </div>
                        <div class="field col">
                            <label>Gate<span class="required-asterisk">*</span></label>
                            <input pInputText formControlName="gate" />
                        </div>
                    </div>
                </div>
            </p-card>
        </div>
        <p-accordion>
            <p-accordionTab header="Fill Gate In Details">
                <fieldset>
                    <div class="details-container">
                        <div class="p-formgroup-inline">
                            <div class="flex-row flex-wrap">
                                <div class="p-field flex-column mt-3 set">
                                    <label>Remark 1</label>
                                    <input pInputText formControlName="remark_1" id="remark_1" />
                                </div>
                                <div class="p-field flex-column mt-3 set">
                                    <label>Remark 2</label>
                                    <input pInputText formControlName="remark_2" id="remark_2" />
                                </div>
                                <div class="p-field flex-column mt-3 set">
                                    <label>Invoice/ Challan No</label>
                                    <input pInputText formControlName="invoice_challan_no">
                                </div>
                                <div class="p-field flex-column mt-3 set">
                                    <label>Docket No </label>
                                    <input pInputText formControlName="docket_no" />
                                </div>
                                <div class="p-field flex-column mt-3 set">
                                    <label>Docket Date</label>
                                    <p-calendar formControlName="docket_date" [iconDisplay]="'input'" [showIcon]="true"
                                        dateFormat="dd/mm/yy" [showButtonBar]="true"></p-calendar>
                                </div>
                                <div class="p-field flex-column mt-3 set">
                                    <label>Unloading Point</label>
                                    <input pInputText formControlName="loading_unloading_point">
                                </div>
                                <div class="p-field flex-column mt-3 set">
                                    <label>Driver</label>
                                    <input pInputText formControlName="driver" />
                                </div>
                                <div class="p-field flex-column mt-3 set">
                                    <label>Vehicle</label>
                                    <input pInputText formControlName="vehicle" />
                                </div>
                                <div class="p-field flex-column mt-3 set">
                                    <label>BOE Date</label>
                                    <p-calendar formControlName="boe_date" [iconDisplay]="'input'" [showIcon]="true"
                                        dateFormat="dd/mm/yy" [showButtonBar]="true"></p-calendar>
                                </div>
                                <div class="p-field flex-column mt-3 set">
                                    <label>Net Weight</label>
                                    <input pInputText formControlName="total_net_weight" />
                                </div>
                                <div class="p-field flex-column mt-3 set">
                                    <label>Gross Weight</label>
                                    <input pInputText formControlName="total_gross_weight" />
                                </div>
                                <div class="p-field flex-column mt-3 set">
                                    <label>Net Value</label>
                                    <input pInputText formControlName="net_value">
                                </div>

                                <div class="p-field flex-column mt-3 set">
                                    <label>E Way Bill No</label>
                                    <input pInputText formControlName="e_way_bill_no">
                                </div>
                                <div class="p-field flex-column mt-3 set">
                                    <label>Total Invoice Value</label>
                                    <input pInputText formControlName="total_invoice_value" />
                                </div>
                                <div class="p-field flex-column mt-3 set">
                                    <label>Origin Of Country</label>
                                    <input pInputText formControlName="origin_of_country" />
                                </div>
                                <div class="p-field flex-column mt-3 set">
                                    <label>Created By</label>
                                    <input pInputText formControlName="created_by" />
                                </div>
                                <div class="p-field flex-column mt-3 set">
                                    <label>Created On</label>
                                    <input pInputText formControlName="created_on" />
                                </div>
                                <div class="p-field flex-column mt-3 set">
                                    <label>Received By</label>
                                    <input pInputText formControlName="received_by" />
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
            </p-accordionTab>

        </p-accordion>
        <p-card *ngIf="showAccordion">
            <p-accordion *ngIf="formArray.controls.length > 0">
                <div formArrayName="formArray">
                    <p-accordionTab [header]="'Purchase Order ' + (i + 1)" class="record-details"
                        *ngFor="let group of formArray.controls; let i = index" [formGroupName]="i">
                        <div class="details-container">
                            <fieldset class="section po-details">
                                <legend><strong>PO Details</strong></legend>
                                <div class="p-fluid details-form">
                                    <div class="p-formgroup-inline">
                                        <div class="flex-row flex-wrap">
                                            <div class="p-field flex-column">
                                                <label for="agNumber">PO/Agreement Number</label>
                                                <input id="agNumber" type="text" pInputText
                                                    formControlName="poagreement_no">
                                            </div>
                                        </div>
                                        <div class="p-field flex-column mt-3">
                                            <label>Company Code</label>
                                            <input pInputText formControlName="company_code">
                                        </div>
                                        <div class="p-field flex-column mt-3">
                                            <label>Company Name</label>
                                            <input pInputText formControlName="company_name">
                                        </div>
                                        <div class="p-field flex-column mt-3">
                                            <label>Doc. Cat</label>
                                            <input pInputText formControlName="doc_cat" />
                                        </div>
                                        <div class="p-field flex-column mt-3">
                                            <label>Plant Code</label>
                                            <input pInputText formControlName="plant_code" />
                                        </div>
                                        <div class="p-field flex-column mt-3">
                                            <label>Plant Name</label>
                                            <input pInputText formControlName="plant_name" />
                                        </div>
                                        <div class="p-field flex-column mt-3">
                                            <label>Vendor Code</label>
                                            <input pInputText formControlName="vendor_code" />
                                        </div>
                                        <div class="p-field flex-column mt-3">
                                            <label>Vendor Name </label>
                                            <input pInputText formControlName="vendor_name" />
                                        </div>
                                        <div class="p-field flex-column mt-3">
                                            <label>Purchase Type</label>
                                            <input pInputText />
                                        </div>
                                        <div class="p-field flex-column mt-3">
                                            <label>Document Type</label>
                                            <input pInputText formControlName="doc_type" />
                                        </div>
                                    </div>
                                </div>
                            </fieldset>

                            <fieldset class="section  gate-details">
                                <legend><strong>Gate Details</strong></legend>
                                <div class="p-fluid">
                                    <div class="flex-row flex-wrap">
                                        <div class="p-field flex-column">
                                            <label for="gateNumber">Gate Number</label>
                                            <input id="gateNumber" type="text" pInputText formControlName="gate_number">
                                        </div>
                                        <div class="p-field flex-column mt-2">
                                            <label>Invoice Date</label>
                                            <p-calendar formControlName="invoice_date" [iconDisplay]="'input'"
                                                [showIcon]="true" dateFormat="dd/mm/yy"
                                                [showButtonBar]="true"></p-calendar>
                                        </div>
                                        <div class="p-field flex-column mt-2">
                                            <label>Transpoter Name</label>
                                            <input pInputText />
                                        </div>
                                        <div class="p-field flex-column mt-2">
                                            <label>Gate No</label>
                                            <input pInputText />
                                        </div>
                                        <div class="p-field flex-column mt-2">
                                            <label>Total Number Of Items</label>
                                            <p-calendar [iconDisplay]="'input'" [showIcon]="true" dateFormat="dd/mm/yy"
                                                [showButtonBar]="true"></p-calendar>
                                        </div>
                                        <div class="p-field flex-column">
                                            <label>Total Number Of Items Qty</label>
                                            <input pInputText />
                                        </div>
                                        <div class="p-field flex-column">
                                            <label>Packing Type</label>
                                            <input pInputText formControlName="packing_type" />
                                        </div>
                                        <div class="p-field flex-column">
                                            <label>Number Of Packages</label>
                                            <input pInputText formControlName="number_of_packages" />
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                        <fieldset class="section item-details" *ngIf="recordDetails.poAccordions.length > 0">
                            <legend><strong>Item Details</strong></legend>
                            <p-table [value]="recordDetails.poAccordions[i].items">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>PO No</th>
                                        <th>Item No</th>
                                        <th>Material Code</th>
                                        <th>Material Description</th>
                                        <th>PO Qty</th>
                                        <th>Received Qty</th>
                                        <th>UoM</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-item>
                                    <tr>
                                        <td>{{item.poNumber}}</td>
                                        <td>{{item.itemNo}}</td>
                                        <td>{{item.materialCode}}</td>
                                        <td>{{item.materialDescription}}</td>
                                        <td>{{item.poQty}}</td>
                                        <td>{{item.receivedQty}}</td>
                                        <td>{{item.uom}}</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </fieldset>

                    </p-accordionTab>
                </div>
            </p-accordion>
        </p-card>
        <div style="margin-bottom: 70px;"></div>
    </div>
</form>
<div style="text-align: center;">
    <p-button label="Submit" (click)="onSubmit()"></p-button>
</div>
<div style="margin-top: 70px;"></div>
<p-toast></p-toast> -->

<form [formGroup]="createGateInForm">
    <p-card>
        <div class="col-12 md:col-12">
            <div class="p-fluid">
                <h4>Receiving Detail</h4>
                <div class="p-formgrid grid">
                    <div class="field col">
                        <label><strong>Token No</strong> </label>

                        <p-dropdown [options]="token_no_list" optionLabel="token_no" [filter]="true" filterBy="token_no"
                            [showClear]="true" placeholder="Select a Token No"
                            (onChange)="onTokenNoSelected($event.value)">
                            <ng-template pTemplate="selectedItem" let-selectedOption>
                                <div class="flex align-items-center gap-2">
                                    {{ selectedOption?.token_no }}
                                </div>
                            </ng-template>
                            <ng-template let-token pTemplate="item">
                                <div class="flex align-items-center gap-2">
                                    {{ token?.token_no }}
                                </div>
                            </ng-template>
                        </p-dropdown>
                    </div>
                    <div class="field col">
                        <label><strong> Purpose<span class="required-asterisk">*</span></strong></label>
                        <input pInputText formControlName="purpose" [disabled]="true" />
                    </div>
                    <div class="field col">
                        <label><strong>Plant<span class="required-asterisk">*</span></strong></label>
                        <input pInputText formControlName="plant" />
                    </div>
                    <div class="field col">
                        <label><strong> Gate<span class="required-asterisk">*</span></strong></label>
                        <input pInputText formControlName="gate" />
                    </div>
                    <div class="field col">
                    </div>
                    <div class="field col">
                    </div>
                </div>
                <!-- <div class="p-formgrid grid">
                    <div class="field col">
                        <label>Token No</label>

                        <p-dropdown [options]="token_no_list" optionLabel="token_no" [filter]="true" filterBy="token_no"
                            [showClear]="true" placeholder="Select a Token No"
                            (onChange)="onTokenNoSelected($event.value)">
                            <ng-template pTemplate="selectedItem" let-selectedOption>
                                <div class="flex align-items-center gap-2">
                                    {{ selectedOption?.token_no }}
                                </div>
                            </ng-template>
                            <ng-template let-token pTemplate="item">
                                <div class="flex align-items-center gap-2">
                                    {{ token?.token_no }}
                                </div>
                            </ng-template>
                        </p-dropdown>
                    </div>
                    <div class="field col">
                        <label>Vendor</label>
                        <p-dropdown [options]="vendor_list" placeholder="Select Vendor"
                            (onChange)="getselectedVendorPoList($event.value)"></p-dropdown>
                    </div>
                    <div class="field col">
                        <label>PO</label>
                        <p-multiSelect [options]="all_po_list" optionLabel="name" placeholder="Select PO"
                            (onChange)="onMultiSelectChange($event)"></p-multiSelect>
                    </div>
                    <div class="field col">
                    </div>
                    <div class="field col">
                    </div>
                </div> -->
            </div>
        </div>
    </p-card> <br>

    <p-card>
        <!-- <p-accordion> -->
        <!-- <p-accordionTab header="Gate Details"> -->
        <fieldset class="section gate-info">
            <legend><strong> Gate Details</strong></legend>
            <div class="p-fluid">
                <div class="p-formgrid grid">
                    <div class="field col">
                        <label><strong>Remark 1</strong> </label>
                        <input pInputText formControlName="remark_1" id="remark_1" />
                    </div>
                    <div class="field col">
                        <label><strong>Remark 2</strong></label>
                        <input pInputText formControlName="remark_2" id="remark_2" />
                    </div>
                </div>
                <div class="p-formgrid grid">
                    <div class="field col">
                        <label><strong> Invoice/ Challan No</strong></label>
                        <input pInputText formControlName="invoice">
                    </div>
                    <div class="field col">
                        <label><strong> Invoice Date </strong></label>
                        <p-calendar formControlName="invoice_date" [iconDisplay]="'input'" [showIcon]="true"
                            dateFormat="dd/mm/yy" [showButtonBar]="true"></p-calendar>
                    </div>
                </div>
                <div class="p-formgrid grid">
                    <div class="field col">
                        <label><strong> Transpoter Name</strong></label>
                        <input pInputText />
                    </div>
                    <div class="field col">
                        <label><strong> Driver Name </strong></label>
                        <input pInputText formControlName="driver" />
                    </div>
                </div>
                <div class="p-formgrid grid">
                    <div class="field col">
                        <label><strong> Driver Mobile No</strong></label>
                        <input pInputText formControlName="driver_mobile_no" />
                    </div>
                    <div class="field col">
                        <label><strong> Docket No </strong></label>
                        <input pInputText formControlName="docket_no" />
                    </div>
                </div>
                <div class="p-formgrid grid">
                    <div class="field col">
                        <label><strong> Docket Date</strong></label>
                        <p-calendar formControlName="docket_date" [iconDisplay]="'input'" [showIcon]="true"
                            dateFormat="dd/mm/yy" [showButtonBar]="true"></p-calendar>
                    </div>
                    <div class="field col">
                        <label for="gateNumber"><strong> Gate No</strong></label>
                        <input id="gateNumber" type="text" pInputText formControlName="gate_number">
                    </div>
                </div>

                <div class="p-formgrid grid">
                    <div class="field col">
                        <label><strong> Vehicle </strong></label>
                        <input pInputText formControlName="vehicle" />
                    </div>
                    <div class="field col">
                        <label><strong> Total Number Of Items</strong></label>
                        <input pInputText />
                    </div>
                </div>
                <div class="p-formgrid grid">
                    <div class="field col">
                        <label><strong> Total Number Of Items Qty</strong></label>
                        <input pInputText />
                    </div>
                    <div class="field col">
                        <label><strong> Packing Type</strong></label>
                        <input pInputText formControlName="packing_type" />
                    </div>
                </div>
                <div class="p-formgrid grid">
                    <div class="field col">
                        <label><strong> Number Of Packages</strong></label>
                        <input pInputText formControlName="number_of_packages" />
                    </div>
                    <div class="field col">
                        <label><strong> Net Weight</strong></label>
                        <input pInputText formControlName="total_net_weight" />
                    </div>
                </div>
                <div class="p-formgrid grid">
                    <div class="field col">
                        <label><strong> Gross Weight</strong></label>
                        <input pInputText formControlName="total_gross_weight" />
                    </div>

                    <div class="field col">
                        <label><strong> Unloading Point </strong></label>
                        <input pInputText formControlName="loading_unloading_point">
                    </div>
                </div>
                <div class="p-formgrid grid">
                    <div class="field col">
                        <label><strong> BOE No </strong></label>
                        <input pInputText formControlName="boe_no" />
                    </div>
                    <div class="field col">
                        <label><strong> BOE Date</strong></label>
                        <p-calendar formControlName="boe_date" [iconDisplay]="'input'" [showIcon]="true"
                            dateFormat="dd/mm/yy" [showButtonBar]="true"></p-calendar>
                    </div>
                </div>
                <div class="p-formgrid grid">
                    <div class="field col">
                        <label><strong> E Way Bill No</strong></label>
                        <input pInputText formControlName="e_way_bill_no">
                    </div>
                    <div class="field col">
                        <label><strong> Total Invoice Value</strong></label>
                        <input pInputText formControlName="total_invoice_value" />
                    </div>
                </div>
                <div class="p-formgrid grid">
                    <div class="field col">
                        <label><strong> Origin Of Country </strong></label>
                        <input pInputText formControlName="origin_of_country" />
                    </div>
                    <div class="field col">
                        <label><strong> Created By </strong></label>
                        <input pInputText formControlName="created_by" />
                    </div>
                </div>
                <div class="p-formgrid grid">
                    <div class="field col">
                        <label><strong> Created On </strong></label>
                        <input pInputText formControlName="created_on" />
                    </div>
                    <div class="field col">
                        <label><strong> Received By </strong></label>
                        <input pInputText formControlName="received_by" />
                    </div>
                </div>
            </div>
        </fieldset>
        <!-- </p-accordionTab> -->
        <!-- </p-accordion> -->
        <div *ngIf="showAccordion">
            <p-accordion *ngIf="formArray.controls.length > 0">
                <div formArrayName="formArray">
                    <p-accordionTab [header]="'Purchase Order ' + (i + 1)" class="record-details"
                        *ngFor="let group of formArray.controls; let i = index" [formGroupName]="i">
                        <div class="details-container">
                            <fieldset class="section po-details">
                                <legend><strong>PO Details</strong></legend>
                                <div class="p-fluid details-form">
                                    <div class="p-formgroup-inline">
                                        <div class="p-field flex-column mt-3">
                                            <label for="agNumber"><strong> PO/Agreement Number</strong></label>
                                            <input id="agNumber" type="text" pInputText
                                                formControlName="poagreement_no">
                                        </div>
                                        <div class="p-field flex-column mt-3">
                                            <label><strong> Company Code </strong></label>
                                            <input pInputText formControlName="company_code">
                                        </div>
                                        <div class="p-field flex-column mt-3">
                                            <label><strong> Company Name </strong></label>
                                            <input pInputText formControlName="company_name">
                                        </div>
                                        <div class="p-field flex-column mt-3">
                                            <label><strong> Doc. Cat </strong></label>
                                            <input pInputText formControlName="doc_cat" />
                                        </div>
                                        <div class="p-field flex-column mt-3">
                                            <label><strong> Plant Code </strong></label>
                                            <input pInputText formControlName="plant_code" />
                                        </div>
                                        <div class="p-field flex-column mt-3">
                                            <label><strong> Plant Name</strong></label>
                                            <input pInputText formControlName="plant_name" />
                                        </div>
                                        <div class="p-field flex-column mt-3">
                                            <label><strong> Vendor Code</strong></label>
                                            <input pInputText formControlName="vendor_code" />
                                        </div>
                                        <div class="p-field flex-column mt-3">
                                            <label><strong> Vendor Name </strong></label>
                                            <input pInputText formControlName="vendor_name" />
                                        </div>
                                        <div class="p-field flex-column mt-3">
                                            <label><strong> Purchase Type</strong></label>
                                            <input pInputText />
                                        </div>
                                        <div class="p-field flex-column mt-3">
                                            <label><strong> Document Type</strong></label>
                                            <input pInputText formControlName="doc_type" />
                                        </div>
                                        <div class="p-field flex-column mt-3">
                                        </div>
                                        <div class="p-field flex-column mt-3">
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                        <fieldset class="section item-details" *ngIf="recordDetails.poAccordions.length > 0">
                            <legend><strong>Item Details</strong></legend>
                            <p-table [value]="recordDetails.poAccordions[i].items">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>PO No</th>
                                        <th>Item No</th>
                                        <th>Material Code</th>
                                        <th>Material Description</th>
                                        <th>PO Qty</th>
                                        <th>Received Qty</th>
                                        <th>UoM</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-item>
                                    <tr>
                                        <td>{{item.poNumber}}</td>
                                        <td>{{item.itemNo}}</td>
                                        <td>{{item.materialCode}}</td>
                                        <td>{{item.materialDescription}}</td>
                                        <td>{{item.poQty}}</td>
                                        <td>{{item.receivedQty}}</td>
                                        <td>{{item.uom}}</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </fieldset>

                    </p-accordionTab>
                </div>
            </p-accordion>
        </div>
        <div style="text-align: center;">
            <p-button label="Submit" (click)="onSubmit()"></p-button>
        </div>
    </p-card>
</form>

<!-- <div style="margin-top: 70px;"></div> -->
<p-toast></p-toast>